function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import AdvancedDanmakuPosEditor from './AdvancedDanmakuPosEditor';
import AdvancedDanmakuJsonEditor from './advancedDanmakuJsonEditor';
var AdvancedDanmakuEditor = function () {
    function AdvancedDanmakuEditor(player, el) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, AdvancedDanmakuEditor);
        this.player = player;
        this.el = el;
        this.template = this.player.template;
        this.init();
    }
    _createClass(AdvancedDanmakuEditor, [
        {
            key: 'init',
            value: function init() {
                var _this = this;
                var $ = this.el.querySelector.bind(this.el);
                this.template.ade_pos = $('.mfunsPlayer-ade-pos');
                this.template.ade_json = $('.mfunsPlayer-ade-json');
                this.template.ade_mode_selector = $('.mfunsPlayer-ade-mode-selector');
                this.template.ade_label_pos = $('.mfunsPlayer-ade-mode-selector .label-pos');
                this.template.ade_label_json = $('.mfunsPlayer-ade-mode-selector .label-json');
                this.PosEditor = new AdvancedDanmakuPosEditor(this.player, this.template.ade_pos);
                this.jsonEditor = new AdvancedDanmakuJsonEditor(this.player, this.template.ade_json);
                this.template.ade_label_pos.addEventListener('click', function () {
                    _this.switchMode(7);
                });
                this.template.ade_label_json.addEventListener('click', function () {
                    var _this$jsonEditor$edit;
                    _this.switchMode(9);
                    if (!_this.jsonEditor.editor) {
                        _this.jsonEditor.createEditor();
                    }
                    (_this$jsonEditor$edit = _this.jsonEditor.editor) === null || _this$jsonEditor$edit === void 0 ? void 0 : _this$jsonEditor$edit.focus();
                });
            }
        },
        {
            key: 'switchMode',
            value: function switchMode(mode) {
                this.el.classList.toggle('mode-pos', mode == 7);
                this.el.classList.toggle('mode-script', mode == 8);
                this.el.classList.toggle('mode-json', mode == 9);
            }
        }
    ]);
    return AdvancedDanmakuEditor;
}();
export default AdvancedDanmakuEditor;